import React, {Component} from "react";
import ReactDOM from "react-dom";
import registerServiceWorker from "./registerServiceWorker";
import "./index.css";
import {Container, Grid, Checkbox} from "semantic-ui-react";
import {BrowserRouter as Router, Link, Route} from "react-router-dom";

// import ReactDisqusThread from 'react-disqus-thread';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {movieShow: true};
        this.previousMode = false;
    }

    updateDimensions() {
        var $ = window.$;
        var w = window,
            d = document,
            documentElement = d.documentElement,
            body = d.getElementsByTagName('body')[0],
            width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
            height = w.innerHeight || documentElement.clientHeight || body.clientHeight;
        this.setState({width: width, height: height});
        // if you are using ES2015 I'm pretty sure you can do this: this.setState({width, height});
        if ($('#disqus_thread').html() == '' && window.DISQUS) {
            window.DISQUS.reset({
                reload: true
            })
        }
        ;
        $('.menu .item').tab();
        var video_height = this.state.movieShow ? $('.video-container-root').height() : 0;
        $('.disqus,.youtube').css('height', $(window).height() - video_height - $('.ui.menu').height() - 14);
    }

    function

    doc_keyUp(e) {
        // this would test for whichever key is 40 and the ctrl key at the same time
        if (e.ctrlKey && e.code === 'KeyY') {
            if(window.document.querySelector('.video-container-root').style.display==='none'){
                window.document.querySelector('.video-container-root').style.display='block';
            } else {
                window.document.querySelector('.video-container-root').style.display='none';
            }

        }
    }

    componentWillMount() {
        this.updateDimensions();
    }


    componentDidMount() {
        window.addEventListener("load", this.updateDimensions.bind(this));
        window.addEventListener("resize", this.updateDimensions.bind(this));
        window.$('.menu .item').click(this.updateDimensions.bind(this));


        document.addEventListener('keyup', this.doc_keyUp.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
        window.$('.menu .item').off('click');
    }


    movieDisplayer() {
        if (this.state.movieShow) {
            return {
                position: 'static',
                visibility: 'visible'
            }
        } else {
            return {
                position: 'absolute',
                visibility: 'hidden'
            }
        }
    }


    render() {
        let domain = window.location.origin.replace('https://', '').replace('http://', '').replace(new RegExp(':.+'), '');
        if (this.state.width > 767) {
            return (
                <Container fluid>
                    <Grid columns="2" divided stretched stackable className="content-grid">
                        <Grid.Row>
                            <Grid.Column>
                                <div className="video-container-root">
                                    <div className="video-container">
                                        <iframe className="movie" width="100%" height="100%"
                                                src={`https://www.youtube.com/embed/${this.props.match.params.eventId}?rel=0`}
                                                allowFullScreen/>
                                    </div>
                                </div>
                                <div id="disqus_thread"/>
                            </Grid.Column>
                            <Grid.Column>
                                <iframe width="100%" height="100%"
                                        src={`https://www.youtube.com/live_chat?v=${this.props.match.params.eventId}&embed_domain=${domain}`}/>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Container>
            )
        } else {
            return (
                <Container fluid>
                    <div className="video-container-root" style={this.movieDisplayer.bind(this)()}>
                        <div className="video-container">
                            <iframe className="movie" width="100%" height="100%"
                                    src={`https://www.youtube.com/embed/${this.props.match.params.eventId}?rel=0`}
                                    allowFullScreen/>
                        </div>
                    </div>
                    <div className="ui pointing secondary menu">
                        <a className="item active" data-tab="first">질문 & 답변</a>
                        <a className="item" data-tab="second">실시간 대화</a>
                        <div className="item right floated">
                            <Checkbox toggle checked={this.state.movieShow} onClick={
                                function (event, data) {
                                    this.setState({movieShow: !data.checked}, function () {
                                        this.updateDimensions();
                                    }.bind(this))
                                }.bind(this)
                            }/>
                            <label>영상</label>
                        </div>
                    </div>
                    <div className="ui bottom attached tab segment active disqus" data-tab="first">
                        <div id="disqus_thread"/>
                    </div>
                    <div className="ui bottom attached tab segment youtube" data-tab="second">
                        <iframe width="100%" height="100%"
                                src={`https://www.youtube.com/live_chat?v=${this.props.match.params.eventId}&embed_domain=${domain}`}/>
                    </div>
                </Container>
            )
        }

    }
}


class Disqus extends React.Component {
    constructor(props) {
        super(props);
        console.log(props)
    }

    render() {
        return (
            <div className="Disqus" id="disqus_thread"/>
        );
    }
}


const Basic = () => (
    <Router>
        <div>
            <Route path="/live/:eventId" component={App}/>
            <Route path="/disqus/:disqusId" component={Disqus}/>
        </div>
    </Router>
)

ReactDOM.render(<Basic/>, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js